import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fdf0c1fe&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=fdf0c1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf0c1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf0c1fe')) {
      api.createRecord('fdf0c1fe', component.options)
    } else {
      api.reload('fdf0c1fe', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fdf0c1fe&scoped=true&", function () {
      api.rerender('fdf0c1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/comp/SearchFilterTokens.vue"
export default component.exports